module.exports = __webpack_public_path__ + "static/media/font-logo-stg1.409069a7.svg";